// SnackbarComponent.js
import React from "react";
import { Snackbar as MuiSnackbar } from "@mui/material";
import { Alert } from "@mui/material";
import { useSnackbar } from "../../../context/SnackbarContext";
import { CheckCircle, Error, Info, Warning } from "@mui/icons-material";

export const Snackbar = () => {
  const { snackbar, hideSnackbar } = useSnackbar();

  const getIcon = (icon) => {
    switch (icon) {
      case "check":
        return <CheckCircle />;
      case "error":
        return <Error />;
      case "info":
        return <Info />;
      case "warning":
        return <Warning />;
      default:
        return null;
    }
  };

  return (
    <MuiSnackbar
      open={snackbar.open}
      autoHideDuration={snackbar.duration}
      onClose={hideSnackbar}
      anchorOrigin={snackbar.position}
    >
      <Alert
        onClose={hideSnackbar}
        severity={snackbar.type || "info"}
        icon={getIcon(snackbar.icon)}
      >
        {snackbar.message}
      </Alert>
    </MuiSnackbar>
  );
};
